"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const radio_1 = __importDefault(require("@kyruus/radio"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const use_form_1 = __importDefault(require("../../../form/use-form"));
const styles_1 = require("../../../styles");
const Radio = (0, styled_1.default)(radio_1.default) `
  & label span:last-child {
    font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
  }
  & label {
    padding: 0;
    text-indent: 0;
  }
`;
const isBooleanStr = (str = '') => str === 'true' || str === 'false';
const strToBoolean = (str) => {
    if (str === 'true')
        return true;
    if (str === 'false')
        return false;
    return str;
};
/**
 * Wrapper that allows Radio component to be used within Fields components
 *
 * @param {Object} props React component props
 * @param {string} props.path Path to data
 */
const RadioInput = ({ path }) => {
    const [state, actions] = (0, use_form_1.default)(path, {
        eventProcessor: (event) => {
            const val = event.target.value;
            const changes = isBooleanStr(val) ? strToBoolean(val) : val;
            return changes;
        }
    });
    const { AddOn, config } = state;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(styles_1.FieldErrorWrapper, { errors: state.errors, style: { position: 'relative' } },
                react_1.default.createElement(Radio, { options: config.options.map((o) => (Object.assign(Object.assign({}, o), { value: String(o.value) }))), disabled: config.isReadOnly, row: config.row, selected: String(state.value), onChange: actions.onBlur, "data-testid": path, name: config.label, "aria-describedby": `${path}-errors`, "aria-invalid": state.errors.length > 0 })),
            react_1.default.createElement("div", { id: `${path}-errors` }, state.errors.map((error, index) => (react_1.default.createElement(styles_1.ErrorMessage, { key: `${error}-${index}` }, error))))),
        react_1.default.createElement(AddOn, null)));
};
RadioInput.propTypes = {
    path: prop_types_1.default.string.isRequired
};
exports.default = RadioInput;
exports.defaultConfig = {};
//# sourceMappingURL=index.js.map